<template>
	<div class="image-board">
		<photo-grid :box-height="boxHeight" :box-width="boxWidth" :excess-text="'+ {{count}}'" v-on:clickExcess="triggerClick">
			<img v-for="(item, index) in images" :key="item.url" :src="item.url" @click="() => imageView(index)" />
		</photo-grid>
	</div>
</template>

<script>
import Vue from 'vue';
import imageViewer from 'vue-image-viewer';
import PhotoGrid from 'vue-photo-grid';
Vue.use(PhotoGrid);
Vue.use(imageViewer);
export default {
	props: {
		boxWidth: {
			type: String,
			default: '100%'
		},
		boxHeight: {
			type: String,
			default: '100%'
		},

		/**
		 * @typedef {object} ImageObject
		 * @property {string} name
		 * @property {string} url
		 */
		/**
		 * @param {Array.<ImageObject>} images
		 */
		images: {
			type: Array,
			default: () => []
		}
	},
	created() {
		this.$imageViewer.images(this.images);
	},
	watch: {
		images() {
			console.warn('imageViewer ===> images', this.images);
		}
	},
	methods: {
		imageView(index) {
			this.$imageViewer.index(index);
			this.$imageViewer.show();
		},
		triggerClick() {
			this.imageView(5);
		}
	}
};
</script>

<style lang="scss" scoped>
.image-board {
	width: 100%;
	height: 100%;
	overflow-y: auto;

	.grid-component {
		width: 100%;
		height: 100%;
		cursor: pointer;
		.__image_container {
			& > img {
				background-image: none !important;
				object-fit: contain;
				border: 1px solid white;
			}
			& > img:hover {
				object-fit: cover;
			}
		}
	}
}
</style>
